import { XCircleIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

const Alert = ({ message }) => {
	return (
		<div role="alert" className="alert alert-error">
			<XCircleIcon className="block h-6 w-6" />
			<span>{message}</span>
		</div>
	);
};

Alert.propTypes = { message: PropTypes.string.isRequired };

export default Alert;
